import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Tooltip,
  Title,
  Legend,
  ChartData,
} from 'chart.js';
import { forwardRef } from 'react';
import { Line } from 'react-chartjs-2';
import { ChartJSOrUndefined } from 'react-chartjs-2/dist/types';
import annitationPlugin from 'chartjs-plugin-annotation';

ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Tooltip,
    Title,
    Legend,
    annitationPlugin,
);

interface Props {
    title: string;
    data: ChartData<"line", number[], string>
    idPrefix?: string;
}

type RefType = ChartJSOrUndefined<"line", number[], string>

export const LineChart = forwardRef<RefType, Props>(({ data, title, idPrefix }, ref) => {
    return (
        <Line
            id={`line-chart${idPrefix ? '-'+idPrefix : ''}`}
            ref={ref} 
            options={{
                responsive: true,
                maintainAspectRatio: false,
                plugins: {
                    legend: {
                        position: 'bottom' as const,
                        labels: {
                            boxWidth: 4,
                        }
                    },
                    title: {
                        text: title,
                        display: true,
                    },
                    tooltip: {
                        callbacks: {
                            label: function (item) {
                                const index = item.dataIndex
                                const dataset = item.dataset
                                const label = dataset.label
                                const value = dataset.data[index]
                                if (typeof value === 'number' && String(value).includes('.')) {
                                    return ` ${label}: ${(value as number).toFixed(2)}%`
                                } else {
                                    return ` ${label}: ${value}%`
                                }
                            }
                        }
                    },
                    annotation: {
                        annotations: {
                            acceptableLevel: {
                                type: 'line',
                                yMin: 90,
                                yMax: 90,
                                borderColor: 'black',
                                borderWidth: 2,
                                label: {
                                    backgroundColor: 'rgba(0,0,0,1)',
                                    font: {
                                        size: 11,
                                        weight: 'regular',
                                    },
                                    padding: 2,
                                    borderRadius: 2,
                                    display: true,
                                    position: 'start',
                                    content: 'Acceptable Level',
                                }
                            }
                        }
                    },
                },
                scales: {
                    y: {
                        min: 0,
                        max: 100,
                        ticks: {
                            callback: function(value) {
                                return value + '%';
                            }
                        }        
                    },
                },
            }} 
            data={data} 
        />
    )
})